import React from 'react';
import PrintText from './PrintText';
import { ModelPropertiesParser } from '../commons/modelPropertiesParser';
import Markdown from 'react-markdown';
import remarkGfm from 'remark-gfm';

const MarkdownComp = (props) => {
    const { workflowData, layoutItem: { itemProperties: { markdownConfig } }} = props;
    const markdownField = markdownConfig && markdownConfig.markdownField;
    const content = markdownField ? markdownField.indexOf('{{') == -1 ? ModelPropertiesParser(`{{${markdownField}}}`, workflowData) :
        ModelPropertiesParser(markdownField, workflowData) : '';    
    
    return <div className='markdowndiv'>
        <Markdown remarkPlugins={[remarkGfm]}>{content}</Markdown>
    </div>
}

export default MarkdownComp;
